import { TABLE_ACTION, defaultColDef, defaultColActionDef, statusRenderer, CellParams } from '@qrios/frontend-library';
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { predefinedColumns } from '../table/columns/predefinedColumns';

export const columns = [
  {
    ...defaultColDef,
    flex: 1,
    field: 'name',
    headerName: 'Name',
    sortable: true
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'size',
    headerName: 'Size (approx)',
    sortable: true
  },
  {
    ...predefinedColumns.status({ sortable: true }),
    renderCell: (params: CellParams) => {
      const badge = statusRenderer(params);
      const progress = params.row.progress;
      if (progress !== undefined) {
        return (
          <Box display="flex" alignItems="center">
            {badge}
            <Typography variant="body2" color="textSecondary" style={{ marginLeft: 8 }}>
              {progress}%
            </Typography>
          </Box>
        );
      }
      return badge;
    }
  },
  {
    ...defaultColDef,
    flex: 1,
    field: 'expireDate',
    headerName: 'Time due to expire',
    sortable: true
  },
  {
    ...defaultColActionDef([TABLE_ACTION.DOWNLOAD, TABLE_ACTION.INFO, TABLE_ACTION.DELETE]),
    minWidth: 150
  },
  {
    ...defaultColDef,
    field: 'createDate',
    hide: true
  }
];
